import { lazy } from "react";
import { ERouteMappingKeys } from "./routeKeys";

export const powerTechRoutes = {
  [ERouteMappingKeys.POWER_TECH]: {
    id: "power-tech",
    path: "/integrations/power-tech",
    components: {
      "ups-solutions": lazy(() =>
        import("pages/Sections/Integrations/UPSSolutions").then((p) => ({
          default: p.UPSSolutions,
        })),
      ),
      "power-solutions": lazy(() =>
        import("pages/Sections/Integrations/PowerSolutions").then((p) => ({
          default: p.PowerSolutions,
        })),
      ),
    },
  },
};
